<template>
  <div id="pageError">
    <div class="container">
      <div class="row pt-50">
        <div class="col-md-8 mx-auto mt-50">
          <h1>頁面錯誤</h1>
          <p>您搜尋的頁面不存在，按此回首頁。</p>
          <router-link class="btn btn-sm btn-primary mt-10" to="/">回首頁</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pageError',
};
</script>
<style lang="scss">
@import '@/assets/scss/all.scss';
#pageError {
  min-height: calc(100vh - 300px);
  background-color: $sub-primary-white;
}
</style>
